import { RESET_ALL_MATERIELS } from '../../../constants/MaterielConstants'
import {
    RECEIVE_ALL_ANTENNAS,
    RECEIVE_ANTENNA,
    RECEIVE_ALL_ANTENNA_SITUATIONS,
    RECEIVE_ANTENNAS_LAST_SITUATIONS,
    RECEIVE_ANTENNA_TYPES,
    RESET_ANTENNA,
} from '../constants/AntennaConstants'
import { getAntennaType } from '../dto/AntennaTypeShape'
export const store = {
    antennas: [],
    antenna: {},
    antennaSituations: [],
    antennasLastSituations: [],
    antennaTypes: [],
}

const toAntenna = antenna => ({ ...antenna, materielType: antenna.antenneType })

const toAntennaSituation = situation => ({
    ...situation,
    id: situation.idAntenneSituation,
    idAntenne: situation.idAntenne,
    materielId: situation.idAntenne,
    headers: ['siteType', 'siteName', 'statusCode', 'comment', 'situationDate', 'situationEndDate'],
})

export function AntennaReducer(state = {}, action) {
    switch (action.type) {
        case RECEIVE_ALL_ANTENNAS:
            return {
                ...state,
                antennas: action.antennas.map(toAntenna),
            }
        case RECEIVE_ANTENNA:
            return {
                ...state,
                antenna: toAntenna(action.antenna),
            }
        case RECEIVE_ALL_ANTENNA_SITUATIONS:
            return {
                ...state,
                antennaSituations: action.antennaSituations.map(toAntennaSituation),
            }
        case RECEIVE_ANTENNAS_LAST_SITUATIONS:
            return {
                ...state,
                antennasLastSituations: action.antennasLastSituations.map(toAntennaSituation),
            }
        case RECEIVE_ANTENNA_TYPES:
            return {
                ...state,
                antennaTypes: action.antennaTypes.map(getAntennaType),
            }
        case RESET_ANTENNA:
            return {
                ...state,
                antenna: {},
                antennaSituations: [],
            }
        case RESET_ALL_MATERIELS:
            return {
                ...state,
                ...store,
            }
        default:
            return state
    }
}
